import React from 'react';
import styled from 'styled-components';

const Error = () => {
    return(
        <ErrorArea>
            <h2>notice</h2>
            <p>Our servers have detected you are using an outdated browser!</p>
            <p>Unfortunately, this web application doesn't support your browser. Please use an alternative option - we recommend Google Chrome!</p>
        </ErrorArea>
    )
};

const ErrorArea = styled.div`
    display: flex;
    flex-direction: column;
    padding:3em;

    h2{
        font-size: 4em;
        font-family: 'MarkPro-Light';
    }

    p{
        margin: 10px 0;
        font-size: 1.4em;
    }
`;

export default Error;